import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login,
    meta:
    {
      contentOnly:true
    }
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: {
      authRequires: true
    }
    
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue'),
    meta: {
      authRequires: true
    }
  },
  {
    path: '/updateprofile',
    name: 'updateprofile',
    component: () => import('../views/SocietyProfile.vue'),
    meta: {
      authRequires: true
    }
  },
  {
    path: '/profile',
    name: 'SocietyProfile',
    component: () => import('../views/ViewProfile.vue'),
    meta: {
      authRequires: true
    }
  },
  {
    path: '/members',
    name: 'Member',
    component: () => import('../views/Members.vue'),
    meta: {
      authRequires: true
    }
  },
  {
    path: '/collection',
    name: 'MilkCollection',
    component: () => import('../views/MilkBookEntry.vue'),
    meta: {
      authRequires: true
    }
  },
  {
    path: '/register',
    name: 'MilkRegister',
    component: () => import('../views/MilkRegister.vue'),
    meta: {
      authRequires: true
    }
  },
  {
    path: '/report',
    name: 'MilkReport',
    component: () => import('../views/MilkReport.vue'),
    meta: {
      authRequires: true
    }
  },
  {
    path: '/submilkreport',
    name: 'submilkreport',
    component: () => import('../views/SubMilkReport.vue'),
    meta: {
      authRequires: true
    }
  },
  {
    path: '/submilkdetails',
    name: 'submilkdetails',
    component: () => import('../views/SubMilkDetails.vue'),
    meta: {
      authRequires: true
    }
  },
  {
    path: '/memberdetails',
    name: 'memberdetails',
    component: () => import('../views/MemberDetails.vue'),
    meta: {
      authRequires: true
    }
  },
  {
    path: '/bill',
    name: 'bill',
    component: () => import('../views/Bill.vue'),
    meta: {
      authRequires: true
    }
  },
  {
    path: '/billdetails',
    name: 'billdetails',
    component: () => import('../views/BillDetails.vue'),
    meta: {
      authRequires: true
    }
  },
  {
    path: '/membermilkregister',
    name: 'MemberMilkRegister',
    component: () => import('../views/MemberMilkRegister.vue'),
    meta: {
      authRequires: true
    }
  },
  {
    path: '/addmember',
    name: 'AddMember',
    component: () => import('../components/AddMember.vue')
  }
  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});


let token="";
if (localStorage.token) {
   token = localStorage.token;
}


router.beforeEach((to, from, next) => {
  
   if (to.meta.authRequires) {
        if (token == "") {
            next('/');
        }
    }
    
    next();

});

export default router
